import Page from './Page';
import Component from 'vue-class-component';

import template from './IssueReceipt.vue.html';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';
import { format, isSameMonth } from 'date-fns';
@Component({ template, components: { TabBar, HeaderComponent } })
export default class IssueReceipt extends Page {
    status: 'idle' | 'loading' = 'idle';

    addressee_input_method: 'select' | 'text' = 'select';
    addressee_selection: 'guest_name' | 'company_name' = 'guest_name';
    addressee_text: string = '';

    receipt_urls: string[] = [];
    canDownloadReceipt: boolean = false;
    isCancellationFee: boolean = false;

    async created() {
        this.isCancellationFee = this.app.reserve?.canceled ?? false;
        await this.app.fetchInfo();

        const r = await this.app.post('load-receipts');
        if (!r.succeed) throw new Error(r.error);
        this.receipt_urls = r.urls;
        this.canDownloadReceipt = r.downloadable;
    }

    async loadReceiptUrl(): Promise<string | null> {
        const r = await this.app.post('load-receipts');
        if (!r.succeed) throw new Error(r.error);
        return r.urls.length === 1 ? r.urls[0] : null;
    }

    async issue() {
        this.status = 'loading';
        try {
            if (this.receipt_urls.length === 1) {
                open(this.receipt_urls[0]);
                this.status = 'idle';
                return;
            }
            const addressee =
                this.addressee_input_method === 'select'
                    ? this.app.addressee_options[this.addressee_selection]
                    : this.addressee_text;
            if (!addressee) {
                alert();
                this.status = 'idle';
                return;
            }
            const issueReceiptResponse = await this.app.post('issue-receipt', {
                addressee,
            });
            if (!issueReceiptResponse.succeed)
                throw new Error(issueReceiptResponse.error);
            const url = await this.loadReceiptUrl();
            if (url) open(url);
            this.status = 'idle';
        } catch (e) {
            this.status = 'idle';
            throw e;
        }
    }

    downloadReceipt(index: number) {
        if (this.canDownloadReceipt) open(this.receipt_urls[index]);
    }

    accommodationPeriod() {
        if (!this.app.reserve) return '';
        const checkin = new Date(this.app.reserve.checkin);
        const checkout = new Date(this.app.reserve.checkout);
        return (
            format(checkin, 'Y.MM.dd') +
            ' ~ ' +
            (isSameMonth(checkin, checkout)
                ? format(checkout, 'dd')
                : format(checkout, 'MM.dd'))
        );
    }
}
